import { useState } from "react";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "../schools/SchoolsTable.css";
import { NavLink } from "react-router-dom";
import { empty } from "../../../../Utilities/utils";
import colors from "../../../../config/colors";

export default function SubscriptionPackagesTable({
  packages,
  goToUpdatePackageScreen,
  onSearchChange,
  search = "",
  rows = 50,
  totalRecords,
  first,
  onPageChange,
  onSearchBlur,
}) {
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });
  const [selectedSchool, setSelectedSchool] = useState(null);

  const getSeverity = (status) => {
    switch (status) {
      case false:
        return "danger";

      case true:
        return "success";
      default:
        return "danger";
    }
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <Tag
        value={
          !empty(rowData.active) && rowData.active === "yes"
            ? "ACTIVE"
            : "IN-ACTIVE"
        }
        severity={getSeverity(rowData.active === "yes")}
      />
    );
  };

  const titleBodyTemplate = (rowData) => {
    return (
      <NavLink to="" style={{ textDecoration: "none", color: "#000000" }}>
        {!empty(rowData.title) ? rowData.title : "N/A"}
      </NavLink>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div style={{ display: "flex", gap: 15 }}>
        <Button
          icon="pi pi-pencil"
          style={{
            backgroundColor: "transparent",
            color: colors.primary,
            borderColor: colors.primary,
            borderWidth: 1,
            borderRadius: "50%",
            width: 30,
            height: 30,
            fontSize: 8,
          }}
          onClick={() => goToUpdatePackageScreen(rowData)}
        />
      </div>
    );
  };

  const onKeyPress = (event) => {
    if (event.key === "Enter") {
      onSearchBlur(event);
    }
  };

  const renderHeader = () => {
    return (
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          value={search}
          onChange={onSearchChange}
          onBlur={onSearchBlur}
          onKeyPress={onKeyPress}
          placeholder="Student Search"
        />
      </span>
    );
  };
  const header = renderHeader();

  return (
    <div className="datatable">
      <DataTable
        value={packages}
        paginator
        rows={rows}
        header={header}
        filters={filters}
        onFilter={(e) => setFilters(e.filters)}
        selection={selectedSchool}
        onSelectionChange={(e) => setSelectedSchool(e.value)}
        selectionMode="single"
        dataKey="_id"
        stateStorage="session"
        stateKey="dt-state-demo-local"
        emptyMessage="No subscription packages found."
        tableStyle={{ minWidth: "100%" }}
        onPage={onPageChange}
        lazy={true}
        totalRecords={totalRecords}
        first={first}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="title"
          body={titleBodyTemplate}
          header="Package Title"
          sortable
          style={{ width: "40%" }}
        ></Column>
        <Column
          field="package_type"
          header="Package Type"
          sortable
          style={{ width: "15%" }}
        ></Column>
        <Column
          field="cost"
          header="Cost per unit (NGN)"
          sortable
          style={{ width: "15%" }}
        ></Column>
        <Column
          field="status"
          header="Status"
          body={statusBodyTemplate}
          sortable
          filterMenuStyle={{ width: "14rem" }}
          style={{ width: "15%" }}
        ></Column>
        <Column
          header="Action"
          body={actionBodyTemplate}
          exportable={false}
          style={{ width: "15%" }}
        ></Column>
      </DataTable>
    </div>
  );
}
